import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LogoutButton from './LogoutButton';
import AdminPanel from './AdminPanel';

const { FiLink, FiZap, FiSettings } = FiIcons;

const Header = ({ onLogout }) => {
  const [showAdminPanel, setShowAdminPanel] = useState(false);

  return (
    <>
      <motion.header
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-white/80 backdrop-blur-sm border-b border-emerald-100 sticky top-0 z-40"
      >
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-3"
            >
              <div className="relative">
                <div className="absolute inset-0 bg-emerald-500 rounded-full blur-md opacity-30"></div>
                <div className="relative bg-gradient-to-r from-emerald-500 to-teal-600 p-3 rounded-full">
                  <SafeIcon icon={FiLink} className="text-white text-2xl" />
                </div>
              </div>
              <div>
                <h1 className="text-3xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                  NurulQuran Link
                </h1>
                <p className="text-gray-600 text-sm flex items-center space-x-1">
                  <SafeIcon icon={FiZap} className="text-emerald-500" />
                  <span>Fast & Reliable URL Shortening</span>
                </p>
              </div>
            </motion.div>
            
            <div className="flex items-center space-x-3">
              <motion.button
                onClick={() => setShowAdminPanel(true)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center space-x-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
                title="Admin Panel"
              >
                <SafeIcon icon={FiSettings} />
                <span>Admin</span>
              </motion.button>
              
              <LogoutButton onLogout={onLogout} />
            </div>
          </div>
        </div>
      </motion.header>

      <AdminPanel 
        isOpen={showAdminPanel} 
        onClose={() => setShowAdminPanel(false)} 
      />
    </>
  );
};

export default Header;